import React from "react";
import PartnersAndSupportersAdmin from "../partners-and-supporters";
import PartnersAndSupporters from "../partners-and-supporters/partners-and-supporters";
import NewsAndMedia from "./newsAndMedia";
import Newsletter from "./Newsletter";
import Brochures from "./brochures";
import AdminImpact from "../impact/mapImpact";
import Banner from "./banner";
import Nurturing from "./nuturing";
import Fellowship from "./shaping";
import Enterprenurs from "./entrepreneurs";
import Goal from "./goal";
import VissionMission from "./vision";
import Social from "./social";
import JoinFamily from "./joinFamily";
import Mappoints from "./mapPoints";
import Highlights from "./caseStudy";
import ChartGraph from "./sectors";
import SelectionSection from "./impact";
import FounderSection from "./founder";

export default function Index() {
  return (
    <div className=" px-4">
      <Banner />
      <Nurturing />
      <Fellowship/>
       <Enterprenurs />
        <VissionMission />
         <Goal />
            <FounderSection />
         <SelectionSection />
         <ChartGraph />
          <Social />
          <Highlights />
        <AdminImpact
        section="12"
        title="Impact on tackling poverty, unemployment, and climate change since 2018."
      />
       <NewsAndMedia section="13" />
      <Newsletter />
      <Brochures section="13" />
        <JoinFamily />
        <PartnersAndSupporters section="15" />
     
     
   
   
   
   
      
     
    </div>
  );
}
